import React from "react"
import PropTypes from "prop-types"
import IcomoonReact from "icomoon-react"
import iconSet from "./selection.json"

/**
 * Pour rajouter une icone :
 *    - la rajouter dans selection.json (fichier qui a été généré sur https://icomoon.io/)
 *    - l'ajouter dans la liste ci-dessous
 */
export const ICONS = [
  "location2",
  "circle-right",
  "newspaper",
  "address-book",
  "calendar",
  "file-empty",
  "profile",
  "notification",
  "circle-up",
  "facebook",
  "instagram",
  "twitter",
  "youtube",
  "linkedin2",
  "search",
  "home",
  "chevron-thin-up",
  "chevron-thin-down",
  "earth",
  "eye",
  "mail",
  "phone",
  "info",
]

const Icon = ({ size, icon, className }) => {
  return (
    <IcomoonReact
      iconSet={iconSet}
      size={size}
      icon={icon}
      color="currentColor"
      className={className}
      aria-hidden={true}
    />
  )
}

//-----------------------Prop-Types---------------------------//

Icon.defaultProps = {
  icon: 20,
}
Icon.propTypes = {
  icon: PropTypes.oneOf(ICONS),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
}

//-----------------------Prop-Types---------------------------//

export default Icon
